module.exports = __webpack_public_path__ + "images/slick.7fe747f4.svg";